export default __webpack_public_path__ + "static/media/004.538e0009.svg";